class Attributes {
}

Attributes.featuredAssetAttributes = [
  'id',
  'asset_id',
  'customer_grid',
  'customer_carousel'
];

Attributes.customerOnboardingAttributes = [
  "id",
  "profile_name",
  "profile_avatar",
  "profile_interests",
  "account_type",
  "account_business_name",
  "account_industry",
  "subscription_type",
  "payment_billing_method",
  "payment_address",
  "vendor_contact_sales",
  "vendor_setup_docs",
  "vendor_contracts_signed",
  "vendor_purchase_order_issued"
]

Attributes.contributorExportSettings = [
  'watermark_url',
  'original_filename',
  'asset_version_size',
  'usage',
  'exclusivity',
]

Attributes.holdingCompanyAttributes = [
  'id',
  'name'
];

Attributes.projectAttributes = [
  'id',
  'name',
  'description',
  'assets_count',
  'updated_at'
];

Attributes.collectionAttributes = [
  'id',
  'name',
  'description',
  'assets_count',
  'updated_at',
  'featured',
  'main',
  'status',
  'search_query',
  'asset_preview_id',
  'shareable_url'
];

Attributes.paymentAttributes = [
  'id',
  'status',
  'provisioning_data'
];

Attributes.paymentMethodAttributes = [
  'id',
  'stripe_id',
  'brand',
  'name',
  'last_four',
  'expiration'
];

Attributes.organizationAttributes = [
  'id',
  'name',
  'billing_address_line_1',
  'billing_address_line_2',
  'billing_city',
  'billing_state',
  'billing_zip',
  'billing_country',
  'extra_billing_information',
  'billing_address',
  'address_line_1',
  'address_line_2',
  'address_city',
  'address_state',
  'address_zip',
  'address_country',
  'website',
  'industry',
  'phone_number',
  'user_name',
  'auto_approve_comp',
  'organization_type',
  'account_change_request',
  'holding_company_change_request_id',
  'holding_company_id'
];

Attributes.releaseFormAttributes = [
  'id',
  'release_type',
  'submission_id',
  'url',
  'name'
];

Attributes.assetVersionAttributes = [
  'object_changes',
  'created_at',
  'event'
];

Attributes.userInterestAttributes = [
  'id',
  'name',
]

Attributes.userAttributes = [
  'id',
  'avatar_url',
  'job_title',
  'first_name',
  'last_name',
  'email',
  'phone_number',
  'company_name',
  'website_url',
  'slug',
  'country',
  'state',
  'city',
  'postal_code',
  'mailing_address_line_1',
  'mailing_address_line_2',
  'social_links',
  'available_for_assignments',
  'available_social_links',
  'job_title'
];

Attributes.tagAttributes = [
  'id',
  'name'
];

Attributes.categoryAttributes = [
  'id',
  'name'
];

Attributes.subscriptionAttributes = [
  'id',
  'identifier',
  'stripe_price_id',
  'subscription_type',
  'canceled'
];

Attributes.tagCategoryAttributes = [
  'id',
  'name',
  'trending_count'
];

Attributes.assetAttributes = [
  'id',
  'submission_id',
  'name',
  'asset_type',
  'caption',
  'copyright',
  'location',
  'status',
  'notes',
  'keywords',
  'exclusive',
  'usage',
  'premium',
  'published',
  'release_required',
  'asset_url',
  'thumb_url',
  'watermark_medium_url',
  'media_thumb_url',
  'category_ids',
  'tag_ids',
  'metadata',
  'updated_at',
  'reference_number',
  'reference_number_sequence',
  'slug',
  'processing_status',
  'processing_failure_message',
  'buyout_expires_at',
  'rank_featured',
  'ai_approved'
];

Attributes.favoriteAttributes = [
  'id',
  'favorable_id',
  'favorable_type'
];

Attributes.licenseAttributes = [
  'id',
  'asset_id',
  'version_size',
  'valid_asset_version_sizes',
  'agreement_name',
  'created_at'
];

Attributes.licenseAgreementAttributes = [
  'id',
  'name',
  'agreement_type'
];

Attributes.productAttributes = [
  'id',
  'name',
  'asset_version_size',
  'description',
  'cost_type',
  'cost',
  'identifier',
  'product_asset_types',
  'asset_usage_type'
];

Attributes.plansAttributes = [
  'id',
  'interval',
  'identifier',
  'product_name',
  'prices',
  'description',
  'order'
];

Attributes.prefixed = function (prefix, attributes) {
  return attributes.map(attr => `${prefix}.${attr}`)
};

Attributes.assetWithIncludesAttributes = Attributes.assetAttributes
  .concat(Attributes.prefixed('release_forms', Attributes.releaseFormAttributes))

Attributes.pageContentsAttributes = [
  "contributor_name",
  "contributor_url",
  "search_banner_title",
  "search_banner_subtitle",
  "search_banner_url",
  "search_banner_button_title",
  "image_url"
]

export default Attributes;